import { z } from 'zod';

/** Reason attached to a suspension; recorded on the organization's audit trail. */
export const reasonSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(3, { error: 'organizations:validation.reasonMin' })
    .max(500, { error: 'organizations:validation.reasonMax' }),
});

export type ReasonValues = z.infer<typeof reasonSchema>;
